<div class="exception-body error">

    <div class="exception-wrapper">
        <div class="exception-content">
            <img src="assets/layout/images/pages/asset-error.svg" alt="freya-layout" />
            <span>Error</span>
        </div>

    </div>
</div>